import * as React from "react";
import PropTypes from 'prop-types';

const SvgUrgencyPdpQuickadd = props => {
  if (props.id !== "_svgurgencypdpquickadd") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 24 24" {...props}><path fill="#FFF" fillRule="evenodd" d="M8.143 14.22a1.34 1.34 0 110 2.68 1.34 1.34 0 010-2.68zm5.955 0a1.34 1.34 0 110 2.68 1.34 1.34 0 010-2.68zM5.358 4.1a.57.57 0 01.57.529l1.316 7.465h8.097l1.025-5.805a.57.57 0 111.125.198l-1.113 6.317-.008.032a.598.598 0 01-.59.499H6.806a.6.6 0 01-.569-.41l-.022-.088-1.34-7.594H3.072a.572.572 0 110-1.143h2.287zm6.065-.975a.45.45 0 01.446.39l.005.06v2.7h2.699a.45.45 0 01.08.892l-.08.007h-2.7v2.7l-.007.08a.45.45 0 01-.888-.019l-.004-.061v-2.7h-2.7a.45.45 0 01-.08-.892l.08-.008h2.7v-2.7l.006-.08a.45.45 0 01.443-.369z" /></svg>;
};

SvgUrgencyPdpQuickadd.displayName = "_svgurgencypdpquickadd";
SvgUrgencyPdpQuickadd.propTypes = {
  id: PropTypes.string
};
SvgUrgencyPdpQuickadd.defaultProps = {
  id: ''
};
export default SvgUrgencyPdpQuickadd;